export var ProductCondition;
(function (ProductCondition) {
    ProductCondition[ProductCondition["NEW"] = 1000] = "NEW";
    ProductCondition[ProductCondition["MINT"] = 1500] = "MINT";
    ProductCondition[ProductCondition["VERY_GOOD"] = 3001] = "VERY_GOOD";
    ProductCondition[ProductCondition["GOOD"] = 3002] = "GOOD";
    ProductCondition[ProductCondition["ACCEPTABlE"] = 3003] = "ACCEPTABlE";
})(ProductCondition || (ProductCondition = {}));
